import { render, staticRenderFns } from "./DynamicInputsSubmitStepper.vue?vue&type=template&id=9b8c4024&"
import script from "./DynamicInputsSubmitStepper.vue?vue&type=script&lang=js&"
export * from "./DynamicInputsSubmitStepper.vue?vue&type=script&lang=js&"
import style0 from "./DynamicInputsSubmitStepper.vue?vue&type=style&index=0&id=9b8c4024&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports